import { BreakpointObserver } from "@angular/cdk/layout";
import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import moment from "moment";
import { ConfirmationService } from "primeng/api";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { AppleWalletPreferences } from "src/app/shared/models/AppleWalletPreferences.model";
import { EGiftActivationResponseDto } from "src/app/shared/models/DTO/egift-activation-response.dto";
import { EGiftTransaction } from "src/app/shared/models/eGift/EGiftTransaction.model";
import { EGiftVenue } from "src/app/shared/models/eGift/EGiftVenue.model";
import { OOVenue } from "src/app/shared/models/oo-venue";

@Component({
	selector: "app-gift-activate",
	templateUrl: "./gift-activate.component.html",
	styleUrls: ["../gift.style.scss"],
})
export class GiftActivateComponent implements OnInit {
	appleWalletPreferences: AppleWalletPreferences;
	eGiftActivationResponse: EGiftActivationResponseDto;
	eGiftVenue: EGiftVenue;

	isMobile: boolean = false;
	isApple: boolean = false;
	ooVenue: OOVenue;
	transaction: EGiftTransaction;
	transactionGuid: string;
	timestamp = moment().unix();
	venueKey: number;

	constructor(
		private confirmationService: ConfirmationService,
		private focuslink: FocuslinkService,
		private route: ActivatedRoute,
		private storage: LocalDataStoreService,
		private titleService: Title,
		public app: AppService,
		public breakpointObserver: BreakpointObserver
	) {}

	ngOnInit(): void {
		this.venueKey = +this.route.snapshot.paramMap.get("venueKey");
		this.transactionGuid = this.route.snapshot.paramMap.get("transactionGuid");
		this.app.loading(true);
		this.init();
	}

	async init() {
		if (this.venueKey) {
			await this.getVenue(this.venueKey);
			this.titleService.setTitle(`${this.ooVenue.name} Gift Card Activation`);
			if (this.transactionGuid) {
				await this.getTransaction(this.transactionGuid);
				if (this.transaction.purchaserEmail === this.transaction.recipientEmail) {
					this.transaction.recipientFirstName = this.transaction.purchaserFirstName;
					this.transaction.recipientLastName = this.transaction.purchaserLastName;
				}
			}
			if (this.app.deviceService.os === "iOS") {
				this.isApple = true;
			}
		}

		this.app.loading(false);
	}

	async getVenue(venueKey) {
		let resp = await this.focuslink.getOOVenue(venueKey);
		this.ooVenue = new OOVenue(resp);

		resp = await this.focuslink.eGiftVenueGet(venueKey);
		this.eGiftVenue = new EGiftVenue(resp);

		resp = await this.focuslink.appleWalletPreferenceGet(venueKey);
		this.appleWalletPreferences = new AppleWalletPreferences(resp);
	}

	async getTransaction(transactionGuid: string) {
		const resp = await this.focuslink.eGiftTransactionGetOne(this.venueKey, transactionGuid);
		this.transaction = new EGiftTransaction(resp);
	}

	async activateTransaction() {
		this.app.loading(true);
		try {
			const resp = await this.focuslink.eGiftTransactionActivate(this.venueKey, this.transaction.key, this.transaction);
			this.eGiftActivationResponse = new EGiftActivationResponseDto(resp);
			this.app.loading(false);
		} catch (error) {
			this.app.loading(false);
			this.app.msgSvc.add({ severity: "error", detail: error.error });
		}
	}
}
